<template>
  <v-app id="backGND">
    <v-overlay :value="loading" z-index="10" opacity="0.88">
      <div class="loader-card">
        <v-progress-circular indeterminate size="52" width="3" color="white"></v-progress-circular>
        <div class="loader-title">Biblioteca de Videos</div>
        <div class="loader-subtitle">Cargando contenido...</div>
      </div>
    </v-overlay>
    <div id="Library">
      <navBar />
      <div id="triangle_down">
        <div id="triangle_up">
          <h1
            class="rotate"
            style="
              margin: auto;
              text-align: left;
              font-family: 'Poiret One', sans-serif;
              color: white;
              padding-left: 1rem;
              font-size: 3rem;
            "
          >
            Biblioteca de Videos
          </h1>
        </div>
      </div>

      <br />
      <div>
        <b>
          <span
            style="
              margin: auto;
              text-align: left;
              font-family: 'Poiret One', sans-serif;
              color: WHITE;
              padding-left: 1rem;
              font-size: 3rem;
            "
            >VIDEOS RECOMENDADOS DE LA SEMANA</span
          ></b
        >
        <!-- aqui van los videos recomendados  -->
        <div class="d-flex align-center justify-center flex-wrap" style="gap: 8px">
          <v-pagination
            v-model="pageRecommended"
            :length="number_pages_recommended"
            :total-visible="7"
          ></v-pagination>
          <div v-if="number_pages_recommended > 1" class="d-flex align-center" style="gap: 4px">
            <v-text-field
              v-model="jumpToPageRecommended"
              type="number"
              :min="1"
              :max="number_pages_recommended"
              dense
              outlined
              hide-details
              placeholder="Ir a pág."
              style="max-width: 110px"
              @keyup.enter="goToPageRecommended"
            ></v-text-field>
            <v-btn icon small @click="goToPageRecommended">
              <v-icon>mdi-arrow-right</v-icon>
            </v-btn>
          </div>
        </div>
        <v-progress-linear
          v-if="pageLoadingRecommended"
          indeterminate
          color="grey lighten-1"
          height="3"
          style="margin-bottom: 0.5rem"
        ></v-progress-linear>
        <v-card class="desktop" style="background-color: transparent">
          <v-row no-gutters align="stretch" class="ma-2">
            <v-col
              class="desktop"
              cols="12"
              md="5"
              lg="4"
              xl="3"
              sm="6"
              v-for="video in shownCardsRecommended"
              :key="video.id"
            >
              <!-- Llamar el componente de cursos pasandole las props neceserias para el render -->

              <div class="text-center">
                <vidCar
                  :name="video.name"
                  :img="video.img"
                  :instructor="video.instructor"
                  :id="video.id"
                  :serie="video.serie"
                  :description="video.description"
                  :video_type="video.video_type"
                  :dateFormated="video.date"
                  :paginationTab="page"
                ></vidCar>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </div>
      <div style="margin-bottom: 2em; font-size: 1.2em">
        <span class="error_message"
          ><p>{{ error_message }}</p></span
        >
        <span class="warning_message"
          ><p>{{ warning_message }}</p></span
        >
      </div>
      <div v-if="flag_show_content">
        <v-btn
          class="btnFiltro"
          rounded
          color="#4B8072"
          style="color: black"
          @click="selectFilter('Categoría')"
        >
          CATEGORIA
        </v-btn>
        <v-btn
          class="btnFiltro"
          rounded
          color="#4B8072"
          style="color: black"
          dark
          @click="selectFilter('Instructora')"
          >MAESTRA
        </v-btn>
        <v-btn
          class="btnFiltro"
          rounded
          color="#4B8072"
          style="color: black"
          @click="selectFilter('Carpeta')"
          >CARPETA
        </v-btn>
        <br />
        <br />
        <!-- Desktop: v-img gives skeleton placeholder + lazy loading via IntersectionObserver -->
        <div v-if="flag_show_filters" class="imgContainer onlyDesktop">
          <template v-if="flag_category">
            <v-img
              v-for="(url, i) in categoriesUrls"
              :key="'cat-' + i"
              :src="url"
              height="176"
              width="176"
              contain
              class="filter-img"
              @click="categoryFilter(categorys[i])"
            ></v-img>
          </template>
          <template v-if="flag_instructor">
            <v-img
              v-for="(url, i) in instructorsUrls"
              :key="'ins-' + i"
              :src="url"
              height="176"
              width="176"
              contain
              class="filter-img"
              @click="instructorFilter(instructors[i])"
            ></v-img>
          </template>
          <template v-if="flag_folder">
            <v-img
              v-for="(url, i) in foldersUrl"
              :key="'fol-' + i"
              :src="url"
              height="176"
              width="176"
              contain
              class="filter-img"
              @click="folderFilter(folders[i])"
            ></v-img>
          </template>
        </div>

        <!-- Mobile: horizontally scrollable row of filter images -->
        <div v-if="flag_show_filters" class="filter-scroll-mobile onlyMobile">
          <template v-if="flag_category">
            <v-img
              v-for="(url, i) in categoriesUrls"
              :key="'mcat-' + i"
              :src="url"
              height="140"
              width="140"
              contain
              class="filter-img"
              @click="categoryFilter(categorys[i])"
            ></v-img>
          </template>
          <template v-if="flag_instructor">
            <v-img
              v-for="(url, i) in instructorsUrls"
              :key="'mins-' + i"
              :src="url"
              height="140"
              width="140"
              contain
              class="filter-img"
              @click="instructorFilter(instructors[i])"
            ></v-img>
          </template>
          <template v-if="flag_folder">
            <v-img
              v-for="(url, i) in foldersUrl"
              :key="'mfol-' + i"
              :src="url"
              height="140"
              width="140"
              contain
              class="filter-img"
              @click="folderFilter(folders[i])"
            ></v-img>
          </template>
        </div>
        <br />

        <v-btn
          class="btn-class onlyDesktop"
          color="#C8C8C8"
          rounded
          style="color: red"
          @click="clearFilters"
          >Quitar Filtros</v-btn
        >
        <v-btn
          class="btn-class onlyMobile"
          color="#C8C8C8"
          rounded
          style="color: red"
          @click="clearFilters"
          >Quitar Filtros</v-btn
        >
        <br />
        <br />
        <!-- card que contiene los cursos -->
        <div class="d-flex align-center justify-center flex-wrap" style="gap: 8px">
          <v-pagination
            v-model="page"
            :length="number_pages"
            :total-visible="7"
          ></v-pagination>
          <div v-if="number_pages > 1" class="d-flex align-center" style="gap: 4px">
            <v-text-field
              v-model="jumpToPage"
              type="number"
              :min="1"
              :max="number_pages"
              dense
              outlined
              hide-details
              placeholder="Ir a pág."
              style="max-width: 110px"
              @keyup.enter="goToPage"
            ></v-text-field>
            <v-btn icon small @click="goToPage">
              <v-icon>mdi-arrow-right</v-icon>
            </v-btn>
          </div>
        </div>
        <v-progress-linear
          v-if="pageLoading"
          indeterminate
          color="grey lighten-1"
          height="3"
          style="margin-bottom: 0.5rem"
        ></v-progress-linear>
        <div v-if="activeFilter" class="d-flex justify-center mt-2 mb-2">
          <v-chip color="#4B8072" dark close @click:close="clearFilters">
            <v-icon left small>mdi-filter</v-icon>
            {{ activeFilter.type }}: <strong style="margin-left: 4px">{{ activeFilter.value }}</strong>
          </v-chip>
        </div>
        <v-card class="desktop" style="background-color: transparent">
          <v-row no-gutters align="stretch" class="ma-2">
            <v-col
              class="desktop"
              cols="12"
              md="5"
              lg="4"
              xl="3"
              sm="6"
              v-for="video in shownCards"
              :key="video.id"
            >
              <!-- Llamar el componente de cursos pasandole las props neceserias para el render -->

              <div class="text-center">
                <vidCar
                  :name="video.name"
                  :img="video.img"
                  :instructor="video.instructor"
                  :id="video.id"
                  :serie="video.serie"
                  :description="video.description"
                  :video_type="video.video_type"
                  :dateFormated="video.date"
                  :paginationTab="page"
                ></vidCar>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </div>
  </v-app>
</template>
<script>
import navBar from "@/components/navbar";
import vidCar from "@/components/library_components/video_card";
import { mapState, mapGetters } from "vuex";
import { db } from "@/main";
import moment from "moment";

const PER_PAGE = 9;
const PER_PAGE_RECOMMENDED = 3;

export default {
  components: { navBar, vidCar },
  data() {
    return {
      loading: true,
      videos_array: [],
      videos_array_recommended: [],
      page: 1,
      pageRecommended: 1,
      jumpToPage: null,
      jumpToPageRecommended: null,
      pageLoading: false,
      pageLoadingRecommended: false,
      filter: "",
      filters: ["Categoría", "Instructora", "Carpeta", "Fecha"],
      flag_instructor: false,
      instructor: "",
      instructors: ["Paulina", "Ale", "Maritza"],
      instructorsUrls: [
        "https://firebasestorage.googleapis.com/v0/b/balletschool927.appspot.com/o/filters%2Finstructor%2Fpau.png?alt=media&token=18a9cd4a-a78e-4a3a-816f-3a7cb300dad6",
        "https://firebasestorage.googleapis.com/v0/b/balletschool927.appspot.com/o/filters%2Finstructor%2Fale.png?alt=media&token=5fbab423-87c7-43f6-9974-fc2b30ef627b",
        "https://firebasestorage.googleapis.com/v0/b/balletschool927.appspot.com/o/filters%2Finstructor%2Fmaritza.png?alt=media&token=4b4811ee-0199-40ba-b8d1-753ec648d3c8",
      ],
      flag_category: false,
      flag_folder: false,
      folder: "",
      category: "",
      categorys: [
        "Barre Clásico",
        "Cardio Barre",
        "Barre HIIT",
        "Beat Barre",
        "Express",
      ],
      categoriesUrls: [
        "https://firebasestorage.googleapis.com/v0/b/balletschool927.appspot.com/o/filters%2Fcategory%2Fbarre_clasico.png?alt=media&token=7a7f6021-5be7-4e4e-a596-1d196f5c0f95",
        "https://firebasestorage.googleapis.com/v0/b/balletschool927.appspot.com/o/filters%2Fcategory%2Fcardio_barre.png?alt=media&token=0d006a9b-d118-4f51-8fe6-150f72c44b0c",
        "https://firebasestorage.googleapis.com/v0/b/balletschool927.appspot.com/o/filters%2Fcategory%2Fbarre_hiit.png?alt=media&token=fbdd8cc4-48d7-45aa-8628-8945f8b59410",
        "https://firebasestorage.googleapis.com/v0/b/balletschool927.appspot.com/o/filters%2Fcategory%2Fbeat_barre.png?alt=media&token=b18c8bbc-4c56-431b-909e-e0bc75960beb",
        "https://firebasestorage.googleapis.com/v0/b/balletschool927.appspot.com/o/filters%2Fcategory%2Fexpress.png?alt=media&token=c5b7a418-491e-4a11-86e4-9f72890e6007",
      ],
      folders: [],
      foldersUrl: [],
      warning_message: "",
      error_message: "",
      flag_show_content: true,
      flag_show_filters: null,
      activeFilter: null,
    };
  },
  watch: {
    page() {
      this.pageLoading = true;
      setTimeout(() => { this.pageLoading = false; }, 300);
    },
    pageRecommended() {
      this.pageLoadingRecommended = true;
      setTimeout(() => { this.pageLoadingRecommended = false; }, 300);
    },
  },
  computed: {
    // Fix A: pure computeds — no side effects, fixed items per page
    number_pages() {
      return Math.ceil(this.videos_array.length / PER_PAGE);
    },
    number_pages_recommended() {
      return Math.ceil(this.videos_array_recommended.length / PER_PAGE_RECOMMENDED);
    },
    shownCards() {
      const start = (this.page - 1) * PER_PAGE;
      return this.videos_array.slice(start, start + PER_PAGE);
    },
    shownCardsRecommended() {
      const start = (this.pageRecommended - 1) * PER_PAGE_RECOMMENDED;
      return this.videos_array_recommended.slice(start, start + PER_PAGE_RECOMMENDED);
    },
    ...mapState({
      initialTab: (state) => state.pagination.initialTab,
      haveFilter: (state) => state.pagination.haveFilter,
      filterIndex: (state) => state.pagination.filterIndex,
      filterValue: (state) => state.pagination.filterValue,
    }),
    ...mapGetters(["setInitialTabGetter"]),
  },
  methods: {
    mapVideoDoc(doc) {
      const d = doc.data();
      return {
        name: d.video_name,
        instructor: d.instructor,
        img: d.thumbnail,
        serie: d.serie,
        id: d.id,
        description: d.description,
        video_type: d.video_type,
        date: d.video_date ? moment(d.video_date).format("dddd, ll") : "--------",
      };
    },
    goToPage() {
      const p = parseInt(this.jumpToPage);
      if (p >= 1 && p <= this.number_pages) this.page = p;
      this.jumpToPage = null;
    },
    goToPageRecommended() {
      const p = parseInt(this.jumpToPageRecommended);
      if (p >= 1 && p <= this.number_pages_recommended) this.pageRecommended = p;
      this.jumpToPageRecommended = null;
    },
    selectFilter(filtro) {
      this.flag_show_filters = false;
      switch (filtro) {
        case "Categoría":
          this.flag_instructor = false;
          this.flag_category = true;
          this.flag_folder = false;
          this.$store.commit("setFilter", "Categoría");
          break;
        case "Instructora":
          this.flag_category = false;
          this.flag_instructor = true;
          this.flag_folder = false;
          this.$store.commit("setFilter", "Instructora");
          break;
        case "Carpeta":
          this.flag_category = false;
          this.flag_instructor = false;
          this.flag_folder = true;
          this.$store.commit("setFilter", "Carpeta");
          break;
        case "Fecha":
          this.flag_instructor = false;
          this.flag_category = false;
          this.flag_folder = false;
          this.dateFilter();
          break;
      }
      this.flag_show_filters = true;
    },
    clearFilters() {
      this.$store.commit("clearAllPAgination");
      location.reload();
    },
    async categoryVideos(namae) {
      this.loading = true;
      try {
        this.videos_array = [];
        const snap = await db
          .collection("videos")
          .where("category", "==", namae)
          .orderBy("upload_at", "desc")
          .get();
        this.videos_array = snap.docs.map(d => this.mapVideoDoc(d));
      } finally {
        this.loading = false;
      }
    },
    categoryFilter: async function (namae) {
      this.$store.commit("clearInitialTab");
      this.page = 1;
      this.activeFilter = { type: "Categoría", value: namae };
      this.$store.commit("setValueFilter", {
        filterIndex: this.category,
        filterValue: namae,
      });
      this.categoryVideos(namae);
    },
    async instructorVideos(namae) {
      this.loading = true;
      try {
        this.videos_array = [];
        const snap = await db
          .collection("videos")
          .where("instructor", "==", namae)
          .orderBy("upload_at", "desc")
          .get();
        this.videos_array = snap.docs.map(d => this.mapVideoDoc(d));
      } finally {
        this.loading = false;
      }
    },
    instructorFilter: async function (namae) {
      this.$store.commit("clearInitialTab");
      this.page = 1;
      this.activeFilter = { type: "Instructora", value: namae };
      this.$store.commit("setValueFilter", {
        filterIndex: this.instructor,
        filterValue: namae,
      });
      this.instructorVideos(namae);
    },
    async folderVideos(namae) {
      this.loading = true;
      try {
        this.videos_array = [];
        const snap = await db
          .collection("videos")
          .where("serie", "==", namae)
          .orderBy("upload_at", "desc")
          .get();
        this.videos_array = snap.docs.map(d => this.mapVideoDoc(d));
      } finally {
        this.loading = false;
      }
    },
    folderFilter: async function (namae) {
      this.$store.commit("clearInitialTab");
      this.page = 1;
      this.activeFilter = { type: "Carpeta", value: namae };
      this.$store.commit("setValueFilter", {
        filterIndex: this.folder,
        filterValue: namae,
      });
      this.folderVideos(namae);
    },
    async getFolders() {
      this.folders = [];
      this.foldersUrl = [];
      const snap = await db.collection("folders").where("enabled", "==", true).get();
      snap.docs.forEach(doc => {
        this.folders.push(doc.data().name);
        this.foldersUrl.push(doc.data().miniatura);
      });
    },
    async dateFilter() {
      this.videos_array = [];
      const snap = await db.collection("videos").orderBy("upload_at", "desc").get();
      this.videos_array = snap.docs.map(d => this.mapVideoDoc(d));
    },
    async loadRecommendedVideos() {
      const snap = await db.collection("recommend").get();
      const ids = snap.docs.map(d => d.data().video_id).filter(Boolean);
      // Fix C: parallel fetch instead of serial forEach + async
      const videoSnaps = await Promise.all(ids.map(id => db.collection("videos").doc(id).get()));
      this.videos_array_recommended = videoSnaps.filter(s => s.exists).map(s => this.mapVideoDoc(s));
    },
  },
  mounted: async function () {
    moment.locale("es-MX");
    try {

    if (this.haveFilter != null) {
      this.filter = this.haveFilter;
      if (this.haveFilter === "Categoría") {
        this.category = this.filterIndex;
        this.flag_category = true;
        await this.categoryVideos(this.filterValue);
      } else if (this.haveFilter === "Instructora") {
        this.flag_instructor = true;
        await this.instructorVideos(this.filterValue);
      } else if (this.haveFilter === "Carpeta") {
        this.folder = this.filterIndex;
        this.flag_folder = true;
        await this.folderVideos(this.filterValue);
      }
      this.activeFilter = { type: this.haveFilter, value: this.filterValue };
    } else {
      const doc = await db
        .collection("users")
        .doc(this.$store.state.authModule.user.uid)
        .get();
      const data = doc.data();
      let hasPackage = false;

      if (data.role === "admin") {
        const snap = await db
          .collection("videos")
          .where("enabled", "==", true)
          .orderBy("upload_at", "desc")
          .get();
        this.videos_array = snap.docs.map(d => this.mapVideoDoc(d));
        await this.loadRecommendedVideos();
      } else {
        if (data.packages) {
          const end = data.packages[data.packages.length - 1].package_end.toDate();
          const today = new Date();

          if (today > end) {
            this.flag_show_content = false;
            this.error_message = "Tu suscripción esta vencida no puedes acceder al contenido.";
          } else {
            hasPackage = true;
            const diff = moment(end).diff(moment(today), "days");
            if (diff < 5) {
              const fmt = n => ("0" + n).substr(-2);
              this.warning_message =
                "Tu suscripción esta proxima a vencer, vence el día: " +
                `${fmt(end.getDate())}-${fmt(end.getMonth() + 1)}-${end.getFullYear()} ` +
                `a las: ${end.getHours()}:${fmt(end.getMinutes())}:${fmt(end.getSeconds())}`;
            }
          }
        }

        if (hasPackage) {
          const snap = await db
            .collection("videos")
            .where("enabled", "==", true)
            .orderBy("upload_at", "desc")
            .get();
          this.videos_array = snap.docs.map(d => this.mapVideoDoc(d));
          await this.loadRecommendedVideos();
        } else if (!this.error_message) {
          this.flag_show_content = false;
          this.error_message = "No cuentas con suscripción activa.";
        }
      }
    }

    await this.getFolders();

    // Fix B: restore page after data is fully loaded to prevent v-pagination clamping
    if (this.initialTab) this.page = this.initialTab;

    } finally {
      this.loading = false;
    }
  },
  onMounted() {},
  destroyed() {},
};
</script>
<style scoped>
.loader-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  padding: 2.5rem 3.5rem;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}
.loader-title {
  font-family: 'Poiret One', sans-serif;
  font-size: 1.5rem;
  color: white;
  letter-spacing: 0.1em;
  margin-top: 0.25rem;
}
.loader-subtitle {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.55);
  letter-spacing: 0.12em;
  text-transform: uppercase;
}
.error_message {
  font-weight: 900;
  font-size: 1.1em;
  color: red;
  text-align-last: center;
}

.warning_message {
  font-weight: 900;
  font-size: 1.1em;
  color: yellow;
  text-align-last: center;
}

#triangle_up {
  height: 10rem;

  background: linear-gradient(
    to top left,
    rgba(255, 0, 0, 0) 0%,
    rgba(255, 0, 0, 0) 50%,
    rgba(0, 0, 0, 1) 50%,
    rgba(0, 0, 0, 1) 100%
  );
}
#triangle_down {
  height: 10rem;

  background: linear-gradient(
    to top right,
    rgba(255, 0, 0, 0) 0%,
    rgba(255, 0, 0, 0) 50%,
    rgba(200, 200, 200, 1) 50%,
    rgba(200, 200, 200, 1) 100%
  );
}
.rotate {
  transform: rotate(-5deg);
}
.field {
  margin-top: -20px;
}
.centered_input input {
  text-align: center;
}
@media (min-width: 768px) {
  .desktop {
    padding: 1rem !important;
  }
}
#backGND {
  background-image: url("../assets/back.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  margin-top: auto;
}
.imgContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}
.filter-img {
  cursor: pointer;
  border-radius: 6px;
  flex-shrink: 0;
  transition: opacity 0.15s ease;
}
.filter-img:hover {
  opacity: 0.85;
}
.filter-scroll-mobile {
  display: flex !important;
  width: 100%;
  box-sizing: border-box;
  overflow-x: auto;
  gap: 0.75rem;
  padding: 0.5rem 1rem;
  -webkit-overflow-scrolling: touch;
}
.btnFiltro {
  /* font-family: Karantina; */
  font-size: 1.5rem;
  color: rgb(255, 255, 255);
  text-align: center;
  padding: 2rem !important;
  margin-left: 1rem;
  margin-bottom: 1rem;
}

@media (max-width: 900px) {
  .onlyMobile {
    display: inline-flex;
  }
  .onlyDesktop {
    display: none !important;
  }
}
@media (min-width: 900px) {
  .onlyMobile {
    display: none !important;
  }
  .onlyDesktop {
    display: inline-flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/library.vue